function getRootDomain(hostname: string): string {
  const parts: string[] = hostname.split('.');
  return parts.length > 2 ? parts.slice(-2).join('.') : hostname;
}

function setCookie(key: string, value: string, document: Document): void {
  let cookieString: string = encodeURIComponent(key) + '=' + encodeURIComponent(value) + ';';
  const expiryDays: number = 3;
  const dateExpires: Date = new Date(new Date().getTime() + expiryDays * 1000 * 60 * 60 * 24);
  const domain: string = getRootDomain(document.location.hostname);
  cookieString += 'expires=' + dateExpires.toUTCString() + ';';
  cookieString += 'path=' + '/' + ';';
  cookieString += 'domain=.' + domain + ';';
  document.cookie = cookieString;
}

export function setReleaseVersion(releaseVersion: string, document: Document): void {
  const bcfRoot: Element | undefined = Array.from(document.getElementsByTagName('bcf-root'))?.[0];
  bcfRoot?.setAttribute('bcf-version', releaseVersion);
  setCookie('bcfVersion', releaseVersion, document);
  setCookie('bcfAppRuntimeId', new Date().getTime().toString(), document);
}
